import { useFieldValue } from "components/form/input/NestedField";
import TextInput from "components/form/input/TextInput";
import ApontamentoColetas from "entity/Indicador/components/apontamento/fields/ApontamentoColetas";
import ApontamentoCommonFields from "entity/Indicador/components/apontamento/fields/ApontamentoCommonFields";
import ApontamentoImages from "entity/Indicador/components/apontamento/fields/ApontamentoImages";
import ApontamentoClienteParams, {
    ApontamentoParamItem,
} from "entity/Indicador/components/apontamento/fields/ApontamentoClienteParams";
import ApontamentoAmostraParams, {
    useTipoApontamento,
} from "entity/Indicador/components/apontamento/fields/ApontamentoAmostraParams";
import ApontamentoResultado from "entity/Indicador/components/apontamento/fields/ApontamentoResultado";
import ApontamentoObservacao from "entity/Indicador/components/apontamento/fields/ApontamentoObservacao";
import { useEffect, useMemo } from "react";
import Piso from "..";
import FormRow from "components/form/FormRow";
import SelectInput from "components/form/input/SelectInput";
import { useForm } from "react-final-form";
import EntitySearchInput from "components/form/EntitySearch/EntitySearchInput";
import Operador from "entity/Operador";

export default function PisoEditFields({ visita, TipoClass }) {
    const [tipo, setTipo] = useTipoApontamento();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const params = useMemo(() => visita.cliente.getParams(Piso, "Mecanizado", TipoClass), [visita.cliente]);

    const [apontamento] = useFieldValue();
    const form = useForm();

    useEffect(() => {
        if (tipo !== "Mecanizado") {
            setTipo("Mecanizado");
        }
    }, [setTipo, tipo]);

    useEffect(() => {
        if (apontamento) {
            apontamento.conformidade = Piso.calcConformidade(apontamento, params);
            form.change("conformidade", Piso.calcConformidade(apontamento, params));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [apontamento, params]);

    return (
        <>
            <ApontamentoCommonFields
                visita={visita}
                TipoClass={TipoClass}
                showImplemento={false}
                showVariedade
                showCorte
            />

            <ApontamentoAmostraParams tipoFixedValue="Mecanizado">
                {(TipoClass.field === "plantio" || TipoClass.field === "colheitas") && (
                    <FormRow>
                        <EntitySearchInput
                            name="operador"
                            label="Operador"
                            EntityClass={Operador}
                            extraQuery={(query) => query.where("cliente.uid", "==", visita.data.cliente.uid)}
                        />
                    </FormRow>
                )}
                <FormRow>
                    <SelectInput name="turno" label="Turno" options={["A", "B", "C"]} />
                </FormRow>
            </ApontamentoAmostraParams>

            <ApontamentoClienteParams params={params}>
                {params ? (
                    <>
                        <ApontamentoParamItem label="Meta (%):">{params.meta}</ApontamentoParamItem>
                    </>
                ) : null}
            </ApontamentoClienteParams>

            <ApontamentoColetas visita={visita}>
                <TextInput type="number" name="ruasAvaliadas" label="Ruas Avaliadas" />
                <TextInput type="number" name="ruasComPisoteio" label="Ruas Com Pisoteio" />
                <TextInput name="pisoteio" label="Pisoteio (%)" disabled />
            </ApontamentoColetas>

            <ApontamentoResultado conformidadeLabel="Média por Levantamento (%)" />
            <ApontamentoObservacao />
            <ApontamentoImages visita={visita} />
        </>
    );
}
